import { useEffect } from "react";

const useScrollY = (
    setOffset: React.Dispatch<React.SetStateAction<number>>
) => {
    useEffect(() => {
        // scroll part
        // const onScroll = () => setOffset(window.scrollY);
        const onScroll = () =>
            setOffset(
                document.body.scrollTop || document.documentElement.scrollTop // if you set body height to 100vh and overflow auto
            );
        document.body.removeEventListener("scroll", onScroll);
        document.body.addEventListener("scroll", onScroll, { passive: true });
        // clean up code
        return () => document.body.removeEventListener("scroll", onScroll);
    }, []);
};

export default useScrollY;
